<template>  
    <Modal 
        class="failure-modal"
        @close="$emit('close')">
        <span slot="body">
            <span class="failure-body">
                <img class="failure-icon" :src="imgPath + 'icon_alert-yellow.svg'"/>
                <span class="failure-header"><strong>Error</strong></span><br><br>
                <span class="failure-text" v-html="message"></span>
            </span>
        </span>
    </Modal>  
</template>

<script>
import Modal from '@Common/modals/Modal.vue'

export default {
    components: { Modal }, 
    props: ['failureText'],
    data(){
        return {
            message: this.failureText ? this.failureText 
                : "Something went wrong. Kindly contact support for more information.",
            imgPath: process.env.IMAGES_PATH
        }
    }
}
</script>

<style scoped>
.failure-modal{
    z-index: 6000;
}

.failure-header{
    margin-left: 0.5rem;
    font-weight: bold;
    font-size: 30px;
}


.failure-text{
    font-size: 20px;
    color: red
}

.failure-icon{
    width: 30px;
    height: 30px;
    margin-bottom: -5px;
}

/deep/ .modal-container {
  width: auto !important;
  max-width: 45rem !important;
  position: absolute;
  top: 0;
  right: -50vw;
  left:100vw;
  -webkit-animation: slide 1s forwards;
  -webkit-animation-delay: 1s;
  animation: slide 1s forwards;
  animation-delay: 1s;
}

@-webkit-keyframes slide {
    100% { left: 0; }
}

@keyframes slide {
    100% { left: 0; }
}
</style>